import { AvailableListingComponent } from './available-listing/available-listing.component';
import { VsmListingComponent } from './vsm-listing/vsm-listing.component';
import { VipListingComponent } from './vip-listing/vip-listing.component';
import { InactiveListingComponent } from './inactive-listing/inactive-listing.component';
import { RemovedListingComponent } from './removed-listing/removed-listing.component';
import { NoActionComponent } from './no-action/no-action.component';
import { SpamListingComponent } from './spam-listing/spam-listing.component';
import { CycleListingComponent } from './cycle-listing/cycle-listing.component';
import { FollowUpsListingComponent } from './follow-ups-listing/follow-ups-listing.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListMessagesComponent } from './list-messages/list-messages.component';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ViewMessageComponent } from './view-message/view-message.component';
import { ViewMeetingComponent } from './view-meeting/view-meeting.component';
import { EditMeetingComponent } from './edit-meeting/edit-meeting.component';
import { RestoreMeetingComponent } from './restore-meeting/restore-meeting.component';

const routes: Routes = [
  {
    path: 'messages',
    component: AuthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ListMessagesComponent,
      },
      {
        path: 'view/:id',
        canActivate: [AuthGuard],
        component: ViewMessageComponent,
      },
      {
        path: 'view/meeting/:id',
        canActivate: [AuthGuard],
        component: ViewMeetingComponent,
      },
      {
        path: 'restore/meeting/:id',
        canActivate: [AuthGuard],
        component: RestoreMeetingComponent,
      },
      {
        path: 'edit/meeting/:id',
        canActivate: [AuthGuard],
        component: EditMeetingComponent,
      },
      {
        path: 'follow_up',
        canActivate: [AuthGuard],
        component: FollowUpsListingComponent,
      },
      {
        path: 'cycle',
        canActivate: [AuthGuard],
        component: CycleListingComponent,
      },
      {
        path: 'spam',
        canActivate: [AuthGuard],
        component: SpamListingComponent,
      },
      {
        path: 'no_action',
        canActivate: [AuthGuard],
        component: NoActionComponent,
      },
      {
        path: 'remove',
        canActivate: [AuthGuard],
        component: RemovedListingComponent,
      },
      {
        path: 'inactive',
        canActivate: [AuthGuard],
        component: InactiveListingComponent,
      },
      {
        path: 'vip',
        canActivate: [AuthGuard],
        component: VipListingComponent,
      },
      {
        path: 'vsm',
        canActivate: [AuthGuard],
        component: VsmListingComponent,
      },
      {
        path: 'available',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'available',
        },
      },
      {
        path: 'available_in_progress',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'progress',
        },
      },
      {
        path: 'available_placed',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'placed',
        },
      },
      {
        path: 'available_deleted',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'delete',
        },
      },
      {
        path: 'available_future',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'future',
        },
      },
      {
        path: 'unavailable',
        canActivate: [AuthGuard],
        component: AvailableListingComponent,
        data: {
          type: 'unavailable',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeetingsRoutingModule {}
